import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';
import { Area } from 'app/_models/area.model';
import { NormasService } from 'app/_services/normas.service';
import { GlobalEventsManager } from 'app/_services/globaleventsmanager.service';
import { SeguridadService } from 'app/_services/seguridad.service';
import {  Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'modalformularioarea',
  templateUrl: './modalformularioarea.component.html'
})
export class ModalformularioareaComponent implements OnInit {

  @Input() _mostrarmodal: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;
  @Output() onChangeArea = new EventEmitter<any>();

  emisorcambio: any = {
    anadir: false,
    change: false,
    area:0
  }

  area: Area;
  listabloques: any[];

  subscription: Subscription;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager) { }

  ngOnInit() {

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.getListaBloques();
    this.area = new Area();
  }

  ngAfterViewInit(){
    this.abrirModal();

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  abrirModal(){

    if (this._mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(event){
    this.emisorcambio.anadir = false;
    this.onChangeArea.emit(this.emisorcambio);
  }

  getListaBloques(){
    this.normasService.getListaBloques().subscribe(
      data => {
        if (data){
          this.listabloques = data.json().lista;
        }
      }
    );
  }

  guardar(formulario: NgForm, event: Event){
    this.emisorcambio.anadir = true;
    this.onSubmit(formulario,event);
  }

  onSubmit(formulario: NgForm, event: Event){

    event.preventDefault;
    //console.log(formulario);
    let area: any;

    area = {
      abr: this.area.abr,
      descripcion: this.area.descripcion,
      id_bloque: this.area.id_bloque,
      id_area: this.area.id_area
    };

    //console.log(JSON.stringify(norma));

    this.normasService.setArea(area).subscribe(
      data => {
        if (data){
          let area = (data.json().area);
           console.log(data.json().area);
          let al: any = {
            "texto" : "Area guardada",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);
          this.emisorcambio.area = area.id_area;
          this.onChangeArea.emit(this.emisorcambio);
        //  this.updateArea(data);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/normas/modalformularioarea.component.ts